'use client';
import { useCallback } from 'react';
import { useStore } from 'zustand';
import { OpenAPIPath } from './OpenAPIPath';
import { OpenAPISelect, OpenAPISelectItem } from './OpenAPISelect';
import { StaticSection } from './StaticSection';
import { getOrCreateStoreByKey } from './getOrCreateStoreByKey';
function useCodeSampleState(initialKey) {
    if (initialKey === void 0) { initialKey = 'default'; }
    var store = useStore(getOrCreateStoreByKey('codesample', initialKey));
    return {
        key: store.key,
        setKey: useCallback(function (key) { return store.setKey(key); }, [store.setKey]),
    };
}
function OpenAPICodeSampleHeader(props) {
    var data = props.data, items = props.items, selectIcon = props.selectIcon, context = props.context;
    return (<>
            <OpenAPIPath context={context} canCopy={false} withServer={false} data={data}/>
            {items.length > 1 ? (<OpenAPISelect icon={selectIcon} items={items} stateKey="codesample" placement="bottom end">
                    {items.map(function (item) { return (<OpenAPISelectItem key={item.key} id={item.key} value={item}>
                            {item.label}
                        </OpenAPISelectItem>); })}
                </OpenAPISelect>) : items[0] ? (<span className="openapi-codesample-label">{items[0].label}</span>) : null}
        </>);
}
export function OpenAPICodeSampleBody(props) {
    var _a;
    var items = props.items, data = props.data, selectIcon = props.selectIcon, context = props.context;
    if (!items[0]) {
        throw new Error('No items provided');
    }
    var state = useCodeSampleState((_a = items[0]) === null || _a === void 0 ? void 0 : _a.key);
    var selected = items.find(function (item) { return item.key === state.key; }) || items[0];
    if (!selected) {
        return null;
    }
    return (<StaticSection header={<OpenAPICodeSampleHeader context={context} selectIcon={selectIcon} data={data} items={items}/>} className="openapi-codesample">
            <div id={selected.key} className="openapi-codesample-panel">
                {selected.body ? selected.body : null}
                {selected.footer ? selected.footer : null}
            </div>
        </StaticSection>);
}
